import { AnalyticsProvider } from '@axo/shared/services/analytics';
import { LDProvider, basicLogger } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { WhiteLabelWrapper, WhiteLabelWrapperProps } from './WhiteLabelWrapper';

interface MountOptions extends WhiteLabelWrapperProps {
  launchDarklyKey: string;
}

export const mount = (
  form: React.ReactNode,
  { launchDarklyKey, ...options }: MountOptions
) => {
  const scriptId = 'axo-script';
  const divId = 'axo-root';
  const scriptElement = document.getElementById(scriptId);
  const divElement = document.getElementById(divId);
  let root = null;

  if (!scriptElement && !divElement)
    throw new Error(
      `Could not mount the Axo Form: could not find a div with id "${divId}", or script with id "${scriptId}" to mount on.`
    );

  // Backwards compatibility for axoFormV1 where the div element is used for mounting;
  if (divElement) {
    root = createRoot(divElement);
  }

  if (scriptElement && scriptElement.parentNode && !divElement) {
    const generatedDivElement = document.createElement('div');
    generatedDivElement.id = 'axo-root';
    scriptElement.parentNode.insertBefore(generatedDivElement, scriptElement);
    root = createRoot(generatedDivElement);
  }

  root?.render(
    <React.StrictMode>
      <AnalyticsProvider enabledServices={['gtag']}>
        <LDProvider
          clientSideID={import.meta.env.VITE_LAUNCH_DARKLY_CLIENT}
          context={{
            kind: 'form-v2',
            key: launchDarklyKey,
            country: launchDarklyKey,
          }}
          options={{
            logger: basicLogger({
              level: import.meta.env.DEV ? 'info' : 'warn',
            }),
          }}
        >
          <WhiteLabelWrapper {...options}>{form}</WhiteLabelWrapper>
        </LDProvider>
      </AnalyticsProvider>
    </React.StrictMode>
  );
};
